// extracted by mini-css-extract-plugin
export default {"gridInput":"Privacy_gridInput__Fh2x8","inputTextfield":"Privacy_inputTextfield__lBhTQ","error":"Privacy_error__-KI0p","updateButton":"Privacy_updateButton__fOZGJ"};